import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SeoManager from "./SeoManager";
import JsonLd from "./JsonLd";

export default function Layout() {
  const { lang } = useParams<{ lang?: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && ["en", "fr", "da", "de"].includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    } else if (!lang && i18n.language !== "en") {
      i18n.changeLanguage("en");
    }
  }, [lang, i18n]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SeoManager />
      <JsonLd />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}